import { cn } from "@shared/ui";
import { get } from "lodash";

const GENERIC_CARRIER_LOGO = "https://axle-labs-assets.s3.amazonaws.com/carrierLogos/generic.svg";

type CarrierMarkProps = {
  loginInformation: Record<string, any>;
  className?: string;
};

// The selected carrier's logo above a step's title, as in the classic UI; generic when no carrier was picked.
// -mb-2 trims StepBody's 32px gap to 24px between the logo and the title.
const CarrierMark = ({ loginInformation, className }: CarrierMarkProps) => (
  <div className={cn("-mb-2 flex", className)}>
    <span
      role="img"
      aria-label={get(loginInformation, "carrier.name") || "Insurance carrier"}
      style={{ backgroundImage: `url("${get(loginInformation, "carrier.image") || GENERIC_CARRIER_LOGO}")` }}
      className="size-14 rounded-full border border-subtle bg-surface bg-cover bg-center bg-no-repeat"
    />
  </div>
);

export default CarrierMark;
